import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";


export default function TermsOfUse() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="w-screen bg-white py-10 lg:py-16 xl:py-24 px-4 md:px-8 lg:px-16 xl:px-24 text-gray-900">
            <div className="py-16">
                <div>
                    <h1 className="text-4xl font-bold mb-8 text-center">Website Terms and Conditions of Use</h1>

                    <section>
                        <p>
                            These Website Terms and Conditions of Use (“Website Terms”) together with our <a href="https://www.harveynorman.co.nz/corporate-information/online-sale-terms.html" className="text-blue-600 underline mx-1"> Online Sale
                                Terms</a>, <a href="https://www.harveynorman.co.nz/help-and-support.html#returns" className="text-blue-600 underline mx-1">Returns Policy</a>, <a href="https://www.harveynorman.co.nz/help-and-support/pick-up-and-delivery.html" className="text-blue-600 underline mx-1">Click and Collect
                                    and Delivery Terms</a> (“collectively called “Terms and Conditions”)
                            and our <a href="https://www.harveynorman.co.nz/corporate-information/privacy-policy.html" className="text-blue-600 underline mx-1">Privacy
                                Policy</a>,
                            apply when you access, use or purchase goods and services from any of our websites. It is important that
                            you read these Website Terms carefully as by using our websites, you will be deemed to have accepted
                            these Website Terms.

                        </p>

                        <p>&nbsp;</p>
                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">1.</span>
                            <span>GENERAL</span>
                        </h3>
                        <p className="flex items-start mb-2">
                            <span className="min-w-[2rem] ">1.1.</span>
                            <span>
                                Our websites are owned and operated by Harvey Norman Stores (NZ) Pty Limited, trading as Harvey Norman (“Harvey Norman”, "our", "us", or "we").
                            </span>
                        </p>

                        {/* <p className=" position: relative; padding-left: 30px; margin-bottom: 10px; word-wrap: break-word;">
                            <span className=" position: absolute; left: 0; top: 0 ">1.1.</span> Our websites are owned and operated by Harvey Norman Stores (NZ) Pty Limited, trading as Harvey
                            Norman (“Harvey Norman”, "our", "us", or "we"). </p> */}



                        <p className=" flex items-start mb-2">
                            <span className="min-w-[2rem] ">1.2.</span>
                            <span>
                                In these Website Terms, the following definitions apply:
                            </span>

                        </p>

                        <p>&nbsp;</p>

                        <ul className="list-none ml-6 lg:ml-14 mb-4 break-words whitespace-normal">

                            <li> "Order" means any offer made by you, in response to an invitation to treat made by us via the
                                website;
                            </li>
                            <p>&nbsp;</p>
                            <li>
                                <span className="flex flex-wrap  gap-y-1">
                                    <span>“website” or "website(s)” mean the whole or any part of our websites located at</span>

                                    <a href="https://www.harveynorman.co.nz/" className="text-blue-600 underline mx-1">www.harveynorman.co.nz</a>,
                                    <a href="https://www.harveynormancommercial.nz/" className="text-blue-600 underline mx-1">www.harveynormancommercial.nz</a>,
                                    <a href="https://www.harveynormancareers.co.nz/" className="text-blue-600 underline mx-1">www.harveynormancareers.co.nz</a> and
                                    <a href="https://www.harveynormandirect.co.nz/" className="text-blue-600 underline mx-1">www.harveynormandirect.co.nz</a>;
                                </span>
                            </li>
                            <p>&nbsp;</p>
                            <li>“you” means anyone who accesses and/or uses the website(s).</li>
                        </ul>
                    </section>


                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">2.</span>
                            <span>USE OF THE WEBSITES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.1 </span>
                            <span>By accessing, using, or purchasing goods and services from any of our websites, you accept these
                                Website Terms and other laws or regulations which may apply to our websites. By continuing to use our
                                websites, you acknowledge that you have read and understood our Website Terms and agree to be bound by
                                them. If you do not accept these Website Terms, or any of the other Terms and Conditions, you must
                                refrain from using our websites.</span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.2.</span>
                            <span>You may only access, use or purchase goods and services from our websites for your personal use
                                (except commercial use made via <a
                                    href="https://www.harveynormancommercial.nz/" className="text-blue-600 underline mx-1">www.harveynormancommercial.nz</a>), which must be
                                reasonable, or for purposes legitimately connected with purchasing our goods and services. </span>
                        </p>


                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.3.</span>
                            <span>You may only access and use our websites for lawful purposes. When using our websites you must not:</span>
                        </p>


                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(a)</span>
                                <span>use it for fraudulent or unlawful purposes;</span></li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(b)</span> breach any applicable laws or regulations;</li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(c)</span> knowingly transmit any viruses or other disabling feature to our websites;</li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(d)</span> post or transmit any unlawful, threatening, abusive, defamatory, libelous, obscene, or other
                                objectionable material that could give rise to legal proceedings; or</li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(e)</span> copy, distribute, alter or tamper with in, any way, or use any material contained in our
                                websites (except you may print individual pages for your own personal use).</li>
                        </ul>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.4.</span>
                            <span>We use third-party service providers to assist us in the detection of fraudulent activity conducted
                                on our websites. By accessing, using or purchasing from our websites, you accept that your activities
                                on, and interactions with our websites, may be monitored by us or third-party service providers, to
                                identify potentially fraudulent transactions or any other misuse of our websites. In the event that your
                                Order is considered potentially fraudulent, or does not pass the fraud analytic pre-screening process,
                                we reserve the right to cancel your Order, place your Order on hold and request you to provide
                                additional information, or to arrange payment by another method. </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.5.</span>
                            <span>We reserve the right to suspend your access to any of our websites where we consider that you may
                                have breached these Website Terms or the law. If we do this, you may be prevented from accessing all or
                                part of our websites, your account details or other content contained in your account. To the maximum
                                extent permitted by law, we will not be liable to you or any third party for doing this.
                            </span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">3.</span>
                            <span>USER ACCOUNTS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.1.</span>
                            <span>You may access, use and/or purchase goods and services from the website
                                <a href="https://www.harveynorman.co.nz/" className="text-blue-600 underline mx-1">www.harveynorman.co.nz</a>, as a ‘guest’ or as a Harvey
                                Norman account holder.
                                You must be eighteen (18) years of age or over to create an account or purchase goods and services from
                                this website. If you wish to become a member of this website,
                                please complete the online form
                                <a href="https://www.harveynorman.co.nz/index.php?dispatch=profiles.add" className="text-blue-600 underline mx-1">Register for a New Account</a>.
                                We only permit one membership registration per email address.
                            </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.2.</span>
                            <span>After you have created your online account, you will receive an email from us. If you have not
                                received an email within 24 hours,
                                please contact our <a href="https://www.harveynorman.co.nz/customer-services/contact-us.html" className="text-blue-600 underline mx-1">Online
                                    Customer Services Team</a>.
                            </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.3.</span>
                            <span>You must keep your password secure as you are responsible for any activity on your account. You
                                agree to notify us immediately if you become aware of any security breach or any unauthorised use of
                                your password or account. If you forget your password, you may click on the relevant link located on the
                                website and we will email you a link to create a new password,
                                or you may contact our
                                <a href="https://www.harveynorman.co.nz/customer-services/contact-us.html" className="text-blue-600 underline mx-1">Online Customer Services
                                    Team</a>.</span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.4.</span>
                            <span>You agree to keep your account details current at all times by accessing your account via our
                                websites or
                                by contacting our
                                <a href="https://www.harveynorman.co.nz/customer-services/contact-us.html" className="text-blue-600 underline mx-1">Online Customer Services
                                    Team</a>. You must not use another user’s account, without their permission.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.5.</span>
                            <span>We may require you to create an applicant login in order to access certain features of our careers
                                website
                                <a href="https://www.harveynormancareers.co.nz/" className="text-blue-600 underline mx-1">www.harveynormancareers.co.nz</a>. To create an
                                applicant login, you will be re-directed to a third-party
                                website, and upon request, you will be asked to provide your contact details and nominate a password. We
                                only permit one applicant registration per email address. If you have any issues with your applicant
                                login, please contact our Human Resources team
                                at <a href="mailto:human.resources@nz.harveynorman.com" className="text-blue-600 underline mx-1">human.resources@nz.harveynorman.com</a>
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.6.</span>
                            <span>Any personal information provided by you when creating an account with us, will be managed in
                                accordance with our
                                <a href="https://www.harveynorman.co.nz/corporate-information/privacy-policy.html" className="text-blue-600 underline mx-1">Privacy Policy</a>.
                                If you do not provide accurate and complete information, we may not be able to activate
                                your account.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.7.</span>
                            <span>We reserve the right to terminate an account immediately without notice for any reason, including
                                without limitation, where we suspect the account holder has breached these Website Terms or the Online
                                Sales Terms.
                            </span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">4.</span>
                            <span>CONTRACT INFORMATION</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">4.1.</span>
                            <span>The information contained on our websites constitutes an invitation to treat and not an offer to
                                supply goods or services to you. Any Orders you place via our websites, are legally binding offers to
                                buy goods and services, and if accepted by us, a legal contract is formed between you and Harvey Norman,
                                subject to these Website Terms and our Terms and Conditions. We reserve the exclusive right to accept or
                                reject any Order submitted by you for any reason, (in whole or in part), including an error in the
                                advertised price or description of goods, or any Order, we believe, in our sole judgement, to have been
                                placed fraudulently or in an effort to supply trade re-sale.
                            </span>
                        </p>



                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">5.</span>
                            <span>CONTENT OF WEBSITES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.1.</span>
                            <span>Nothing in this clause 5 will limit any rights you may have that cannot be lawfully excluded under
                                these Website Terms, including the rights referred to in clause 18.
                            </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.2.</span>
                            <span>Except as otherwise described in these Website Terms and our Terms and Conditions, all information
                                contained in our websites are made available to provide information about our websites, career
                                opportunities at Harvey Norman, and the goods and services which may be ordered from our websites. While
                                we endeavour to ensure that information on our websites are correct, sometimes errors or inaccuracies do
                                occur, for which we apologise.
                            </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.3.</span>
                            <span>To the maximum extent permitted by law, we do not accept any liability, direct or indirect, for any
                                loss or damage which may directly or indirectly result from any advice, opinion, information,
                                representation or omission, whether negligent or otherwise, contained on our websites. You are solely
                                responsible for the actions you take in reliance on the content on, or accessed, through our websites.
                                We reserve the right to make changes at any time and without notice to you, to any element of our
                                websites. </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.4.</span>
                            <span>To the maximum extent permitted by law, we make no warranties in relation to the fitness for
                                purpose, freedom from computer virus or bugs, accuracy or availability of our websites or any other
                                website that is linked to from our websites. We will not be liable if for any reason our websites are
                                unavailable at any time, or for any period. </span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">6.</span>
                            <span>PRICES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">6.1.</span>
                            <span>All prices on our websites are displayed in New Zealand dollars and includes GST (where applicable).
                                Prices displayed are available in New Zealand only and do not include delivery, installation and
                                handling charges. Prices are valid until amended or removed from the website and are subject to change.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">6.2.</span>
                            <span>We have taken reasonable efforts to provide accurate pricing information on our websites. We reserve
                                the right to correct any pricing errors or alter the prices on our websites and in store, at any time,
                                for any reason, without notice to you. Prices are subject to change by individual Harvey Norman stores
                                and prices displayed may vary in different regions and stores.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">6.3.</span>
                            <span>Images of goods shown without any advertised price beside that image, are not offered for sale.
                                Unless otherwise stated, any accessories shown in any images of goods are not included in the price and
                                may not be available for purchase online or in-store.</span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">7.</span>
                            <span>STOCK AVAILABILITY</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.1.</span>
                            <span>Due to the size of our stores and the popularity of goods, promotions or special prices, goods
                                advertised on the website may vary from what is on display, offered or available for purchase from any
                                of our retail stores, and in some cases may only be available online. Harvey Norman does not guarantee
                                the availability of any specific goods at any time for purchase, either online or in-store. Please call
                                your local Harvey Norman store to enquire whether they have the items on display and/or are available to
                                purchase. </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.2.</span>
                            <span>Goods displayed on our websites are subject to availability in stores and online. We have made
                                reasonable efforts to provide accurate stock availability information on our websites, however we do not
                                guarantee that if a good is classified as being “in stock” that stock will be available to purchase in
                                store or online.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.3.</span>
                            <span>You acknowledge that stock availabilities are subject to change. If we are unable to supply a
                                particular good which has been ordered by you, we will notify you by telephone or email as soon as
                                possible. </span>
                        </p>



                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">8.</span>
                            <span>SPECIFICATIONS AND COLOUR ACCURACY</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">8.1.</span>
                            <span>Every effort is made to ensure that our images of goods are displayed accurately and are as true to
                                colour as possible. However, the actual colour of goods may differ slightly from the goods display
                                image. This is because every computer monitor or device displays colours differently and everyone
                                perceives colour differently. Harvey Norman cannot guarantee that the colour of goods accurately
                                reflects the true colour of goods.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">8.2.</span>
                            <span>Images of goods are for illustration or comparison purposes only. Colours, features, attributes,
                                specifications and sizes may vary from those displayed. Harvey Norman reserves the right to make
                                necessary changes to specifications, features, dimensions and quantities of goods displayed on our
                                websites at any time and without notice. Please check the specifications of a particular good before
                                purchasing. Some items may require self-assembly.</span>
                        </p>



                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">9.</span>
                            <span>CUSTOMER DIRECT</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">9.1.</span>
                            <span>Harvey Norman’s Customer Direct products can be identified by the "Harvey Norman Customer Direct" or
                                “Direct from Supplier” marker on the individual product listing page when using our websites. Customer
                                Direct Products are delivered directly to you by a trusted supplier and are not available in-store or
                                for click and collect. </span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">9.2.</span>
                            <span>We reserve the right to make changes to Customer Direct Product’s specifications, features,
                                dimensions, quantities and delivery details displayed on our websites, at any time and without notice.
                                Please check these details before purchasing.</span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">10.</span>
                            <span>INTELLECTUAL PROPERTY</span>
                        </h3>

                        <p className="flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">10.1.</span>
                            <span>Our websites and all of its contents are Harvey Norman’s (or our licensors’) sole property. All
                                intellectual property rights in, or to our websites, including all intellectual property rights in, or
                                to graphics, logos, trademarks, design, text, icons, the arrangement of them, sound recordings and all
                                software relating to our websites, are owned by us or our licensors. These intellectual property rights
                                may be protected by New Zealand and international laws.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">10.2.</span>
                            <span>You may access our websites and its contents for personal and non-commercial use only, subject to
                                applicable copyright law, including the Copyright Act 1994. You may not in any form or by any means,
                                commercialise any information obtained from any part of our websites, or copy, reproduce, modify,
                                distribute, store, transmit, publish, display within another website or create derivative works from,
                                any part of our websites, without our prior written permission or, in the case of third party material,
                                from the owner of the copyright in that material.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">10.3.</span>
                            <span>Nothing contained in our websites are to be interpreted as a recommendation to use any information
                                on the website in a manner which infringes the intellectual property rights of any person, company or
                                entity. We make no representations or warranties that your use of the information on our websites will
                                not infringe such intellectual property rights.</span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start" >
                            <span className="min-w-[2.6rem]">11.</span>
                            <span>LINKS TO OTHER WEBSITES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">11.1.</span>
                            <span>Our websites may contain links to other third-party websites, which have been provided for your
                                convenience only. We are not responsible for the availability of these links or the content or material
                                contained in these websites. We do not endorse, approve, recommend or give preference to these websites,
                                or any content or information referred to, unless expressly stated. Any representations, warranties or
                                guarantees made on those websites will not be deemed to be made by us.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">11.2.</span>
                            <span>We are not responsible for the privacy practices of the third-party websites in collecting and
                                managing any personal information you provide. You visit these third-party websites at your own risk,
                                and you should make your own enquiries as to the privacy policies of these third parties.
                            </span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start" >
                            <span className="min-w-[2.6rem]">12.</span>
                            <span>SECURE DATA AND TRANSMISSIONS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">12.1.</span>
                            <span>While we take precautions to protect your personal information, unfortunately no data transmission
                                over
                                the internet can be guaranteed as completely secure. Accordingly we cannot warrant that any content or
                                information you transmit via our websites,
                                are totally secure, free from viruses, bugs, fault or other conditions which could damage or interfere
                                with
                                your computer system.
                                You therefore transmit to our websites at your own risk.
                                However, once we receive your transmission, we will take reasonable steps to preserve its security,
                                in accordance with our <a
                                    href="https://www.harveynorman.co.nz/corporate-information/privacy-policy.html" className="text-blue-600 underline mx-1">Privacy Policy</a>.
                                If you become aware of any problems with the security of data or the websites, please contact our
                                Privacy Officer
                                at <a href="mailto:privacy.officer@nz.harveynorman.com" className="text-blue-600 underline mx-1">privacy.officer@nz.harveynorman.com</a>.
                            </span>
                        </p>

                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 flex items-start uppercase">
                            <span className="min-w-[2.6rem]">13.</span>
                            <span>VIRUSES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">13.1.</span>
                            <span>Given the nature of the internet, we cannot guarantee that our websites are free from viruses,
                                faults, bugs or other conditions which could damage or interfere with your computer systems. We do not
                                warrant that your access to our websites will be uninterrupted, error free or that any defects will be
                                corrected. We will not be liable if, for any reason, our websites are unavailable at any time or for any
                                period. You assume the risk of any damage to your property as a result of using our websites, and to the
                                maximum extent permitted by law and without limiting clause 18, we disclaim all liability for any
                                errors, omissions and faults.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">13.2.</span>
                            <span>You must take your own precautions to ensure that the process which you use for accessing our
                                websites does not expose you to the risk of viruses, malicious computer code or other forms of
                                interference which may damage your own computer system. For the avoidance of doubt, we do not accept
                                responsibility for any interference or damage to your own computer system which arises in connection
                                with your use of our websites or any linked website.
                            </span>
                        </p>

                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 flex items-start uppercase">
                            <span className="min-w-[2.6rem]">14.</span>
                            <span>COOKIES</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">14.1.</span>
                            <span>When you access our websites, we may use automated technology (such as cookies and identifiers) to
                                collect information about you to enhance your interaction with our websites and to ensure a more
                                personalised online experience. Cookies are small text files that are placed in your browser by the
                                websites you visit to enable information to be stored and retrieved later by web page servers. Cookies
                                provides us with details about your visit including your IP address, the domain name (whether you are
                                accessing the site from New Zealand or elsewhere, the type of browser and the date, time and duration of
                                your visit.
                            </span></p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">14.2.</span>
                            <span>Some web browsers are set to accept tracking technologies such as cookies. You can choose to
                                disable cookies in your website browser settings and/or delete them from your hard drive. Please note
                                that you may experience a loss of functionality on our websites as a result. For more information about
                                how we use cookies to collect and use information about you, please refer to our
                                <a href="https://www.harveynorman.co.nz/corporate-information/privacy-policy.html" className="text-blue-600 underline mx-1">Privacy Policy</a>.
                            </span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 flex items-start uppercase">
                            <span className="min-w-[2.6rem]">15.</span>
                            <span>PRIVACY POLICY</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">15.1.</span>
                            <span>We are committed to protecting your privacy. We, or our third-parties service providers, may
                                collect personal information directly from you when you access or use our websites, create an online
                                account, place an Order or when you contact us.
                            </span></p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">15.2.</span>
                            <span>We recognise that your personal information is confidential and we understand that it is important
                                for you to know how we treat your personal information. For information about the personal information
                                we collect from you, how we collect it, the purposes for which we use it and the third parties we may
                                share it with, please refer to our
                                <a href="https://www.harveynorman.co.nz/corporate-information/privacy-policy.html" className="text-blue-600 underline mx-1">Privacy Policy</a>.
                            </span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">16.</span>
                            <span>ELECTRONIC AND MARKETING COMMUNICATIONS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">16.1.</span>
                            <span>You agree that we and any of our third parties may, use your email address to send you electronic
                                messages concerning your online account and any Orders you have placed. We may also send you “commercial
                                electronic messages” as defined in the Unsolicited Electronic Messages Act 2007, such as marketing
                                communications and product information, but only if you have separately consented to us doing so. This
                                can be done by signing up to our mailing list or by ticking a box to ‘opt in’ to receiving marketing
                                communications. You also agree that we may contact you by telephone or text to discuss your Order or to
                                arrange delivery or collection </span></p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">16.2.</span>
                            <span>If you would prefer not to receive promotional or other information from us or our third parties,
                                please either use the unsubscribe facility in the applicable commercial electronic message or contact
                                the
                                <a href="https://www.harveynorman.co.nz/customer-services/contact-us.html" className="text-blue-600 underline mx-1">Online Customer Services
                                    Team</a>.
                            </span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">17.</span>
                            <span>DISCLAIMER AND INDEMNITY</span>
                        </h3>

                        <p className=" flex items-start mb-2" >
                            <span className=" min-w-[2.6rem] ">17.1.</span>
                            <span>All of the terms of this disclaimer and indemnity will apply only to the maximum extent permitted
                                by law. Nothing in this clause 17 will limit any rights you may have, or any obligations or liability we
                                may have, that cannot be lawfully excluded under these Website Terms, including those referred to in
                                clause 18.
                            </span></p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">17.2.</span>
                            <span>We make no representations or warranties of any kind, express or implied, in relation to any
                                information, content, materials or products included in our websites or to its availability,
                                functionality or performance, except as otherwise provided under any applicable law.
                            </span></p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">17.3.</span>
                            <span>We do not, nor do our officers, employees, agents and other representatives, accept responsibility
                                for any loss or damage, howsoever caused (including through negligence or matters outside our control),
                                which you may directly or indirectly suffer in connection with your use of our websites or any linked
                                websites, nor do we accept any responsibility for any such loss arising out of your use of, or reliance
                                on, information contained on, or accessed through, these websites. To the maximum extent permitted by
                                law, we disclaim any such representations or warranties as to the completeness, accuracy,
                                merchantability or fitness for purpose of our websites or the information that it contains.</span></p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">17.4.</span>
                            <span>The use of the information on our websites are at your own risk. To the maximum extent permitted by
                                law, we exclude all liability of us, our officers, employees, agents and other representatives in
                                respect of any injury, loss or damage arising out of, or related to, the use, or inability to use, the
                                information on our websites or provided through our websites through email. This limitation of liability
                                includes, but is not limited to, compensatory, direct, indirect or consequential damages, interruption
                                of business, loss of data, income or profit, loss of, or damage to property, and third party claims. If
                                any liability is not able to be excluded by law, we limit our liability to the re-supply of the relevant
                                information or services.
                            </span></p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">17.5.</span>
                            <span>You agree to indemnify us, and our officers, employees, and shareholders, from and against all
                                liability, damages, losses, penalties, fines, expenses and costs (including legal costs) which we incur
                                as a result of your use of our websites in breach of these Website Terms, our lawful use of any
                                information that you provide to us via our websites, or any damage that you may cause to our websites.
                                This indemnification includes, without limitation, liability, damages, penalties, fines, expenses and
                                costs relating to allegations of copyright infringement, defamation, invasion of privacy or trade mark
                                infringement (where we incur these as a result of the aforementioned clauses).</span></p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">18.</span>
                            <span>CONSUMER GUARANTEES ACT 1993 AND FAIR TRADING ACT 1986</span>
                        </h3>

                        <p className="flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">18.1.</span>
                            <span>Nothing in these Website Terms is intended to limit or exclude any rights, obligations or
                                guarantees that cannot lawfully be limited or excluded under the Consumer Guarantees Act 1993 (“CGA”) or
                                the Fair Trading Act 1986. If, and to the extent that any liability we purport to limit or exclude
                                cannot be lawfully limited or excluded, these Website Terms shall be modified to the extent necessary to
                                give effect to the above intention. We do not provide any express guarantees (as that term is defined in
                                the CGA) other than those expressly confirmed in these Website Terms or supplied to you in writing when
                                you purchase goods or services from us.
                            </span></p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">19.</span>
                            <span>FORCE MAJEURE</span>
                        </h3>

                        <p className="flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">19.1.</span>
                            <span>Subject to clause 18, Harvey Norman will not be liable for any errors or delays in performing any
                                of our obligations, including the supply of goods and services, if such errors or delays are caused by
                                circumstances beyond our reasonable control, including but not limited to:
                                <p>&nbsp;</p>
                                <ul className="list-style: none; ml-16; lg:ml-22; mb-4;">
                                    <li className=" flex items-start mb-2">
                                        <span className=" min-w-[2rem] ">(a)</span>
                                        <span>acts of God, declared or undeclared war, threat of war, sabotage, terrorism, riot, civil
                                            disorder, revolution, national or regional emergency, martial law, fire, lightning, flood, cyclone,
                                            earthquake, landslide, storm or other adverse weather conditions, explosion, power shortage, strike,
                                            lock-out or other industrial disturbance, epidemics or pandemics, quarantine, radiation or
                                            radioactive contamination;
                                        </span></li>
                                    <li className=" flex items-start mb-2">
                                        <span className=" min-w-[2rem] ">(b)</span>
                                        <span>failures or interruptions relating to telecommunications, internet, satellite and global
                                            positioning systems; or Government restraint or other intervention or request, Acts of Parliament,
                                            other legislation, or by-law.</span></li>
                                </ul>
                            </span></p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">20.</span>
                            <span>SEVERABILITY</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">20.1.</span>
                            <span>If any provision of these Website Terms are determined by court of competent jurisdiction to be invalid, illegal or unenforceable in any respect, the legality or validity of the remainder of the Website Terms will not be affect and will continue in full force and effect.
                            </span></p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">21.</span>
                            <span>GOVERNING LAWS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">21.1.</span>
                            <span>Our websites and these Website Terms shall be governed by, and construed in accordance with, the laws of New Zealand. You irrevocably and unconditionally submit to the non-exclusive jurisdiction of the courts of New Zealand to resolve any dispute arising in relation to our websites or these Website Terms.
                            </span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">22.</span>
                            <span>OVERSEAS ACCESS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">22.1.</span>
                            <span>Our websites are controlled and operated by us, from offices within New Zealand. They may be accessed in New Zealand and overseas, however the information contained in our websites are intended to apply in New Zealand only and have been prepared in accordance with New Zealand law. We make no representations or warranties that the content of our websites complies with the laws of any country outside New Zealand. If you choose to access this website from outside New Zealand, you are responsible for compliance with applicable local law.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">22.2.</span>
                            <span>We make no representations or warranties to sell any goods or services overseas or that the information or products available from our websites are appropriate or available for use overseas.</span>
                        </p>


                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold mt-8 mb-4 flex items-start">
                            <span className=" min-w-[2.6rem] ">23.</span>
                            <span> AMENDMENTS TO WEBSITE TERMS</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem] ">23.1.</span>
                            <span>We may, from time to time, add or remove information, goods or services from our websites without notice. We reserve the right to update these Website Terms at any time by publishing an updated version on our websites. Any amendments will be effective immediately and by continuing to use our websites, you agree to be bound by these amended Website Terms. We recommend reviewing the Website Terms published to our websites from time to time and before placing an order to understand the terms that apply to you.</span>
                        </p>

                        <p>&nbsp;</p>

                        <p>These Website Terms were last updated on 21 March 2025</p>

                    </section>



                </div>
            </div >

        </div >
    );
}